import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar } from 'swiper';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import useProductList from './useProductList';
import Plug from './icons/Plug';
import Compact from './icons/Compact';
import Outlets from './icons/Outlets';
import Energy from './icons/Energy';
import Time from './icons/Time';
import Phone from './icons/Phone';
import Capacity from './icons/Capacity';
import Seamless from './icons/Seamless';
import Setup from './icons/Setup';
import MultiDay1 from './icons/Multi-Day-1.svg';
import MultiDay2 from './icons/Multi-Day-2.svg';
import editorEventsBus from 'lowcode/utils/editorEventsBus';
import { useGlobal } from '@/utils/useGlobal';

import EcoSection from 'eco-design/base/eco-section';
import EcoButton from 'eco-design/base/eco-button';
import PartnerModal from '../PartnerModal';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { OPEN_QUOTE_WIN_KEY } from '../FreeQuote';

const EmergencyItem = ({ productList, listItem }: { productList: any; listItem: any }) => {
    const { gtm } = useGlobal();
    const { t } = useLang('Emergency');
    const swiperRef = useRef<any>(null);
    const { getSystemTime, useRouter } = useGlobal();
    const [isRegular, setIsRegular] = useState(false);
    const router = useRouter();
    let systemTime = getSystemTime();
    const { _timer } = router.query;
    if (_timer) {
        systemTime = new Date(_timer).getTime();
    }
    useEffect(() => {
        if (systemTime >= new Date('2025/11/03 16:00:00 GMT+8').getTime()) {
            setIsRegular(true);
        }
    }, []);
    const handlePrev = () => {
        swiperRef.current?.slidePrev();
    };

    const handleNext = () => {
        swiperRef.current?.slideNext();
    };

    function handleLink(link: string, item: any) {
        window.open(link, '_blank');
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'select_product',
                product_name: item.title,
                list_name: 'Find Your Versatile Emergency Backup Power For',
                button_name: 'Learn More',
            });
        } catch (error) {}
    }

    function handleBuy(item: any) {
        editorEventsBus.emit('ShopifyCart-add', {
            ...item,

            imageUrl: item.img,
        });

        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'bundle_add_to_cart',
                list_name: t('title'),
                product_name: item.title,
                price: item.price,
                tag: 'none',
                quantity: item.quantity,
                button_name: t('common_card_buy'),
            });
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Search');
            // @ts-ignore
            twq('event', 'tw-o9mqq-ojfq3', {});
        } catch (e) {
            console.error(e);
        }
    }

    return (
        <Swiper
            onSwiper={(swiper) => {
                swiperRef.current = swiper;
            }}
            slidesPerView={'auto'}
            spaceBetween={24}
            modules={[Scrollbar, Navigation]}
            scrollbar={{
                hide: false,
                draggable: true,
                dragSize: 25,
                snapOnRelease: true,
            }}
            navigation={{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }}
            // pagination={{
            //     clickable: true,
            // }}
        >
            {productList
                .filter((item: any) => item.type === listItem.type)
                .map((item: any, index: number) => (
                    <SwiperSlide className="product-item" key={index}>
                        <div className="product-img-wrap">
                            <EcoImg pc={item.img} />
                        </div>
                        <div className="product-info">
                            <div>
                                <div className="product-item-label">{item.label}</div>
                                <div className="product-item-title">{item.title}</div>
                                <div className="product-item-desc">{item.desc}</div>
                            </div>
                            <div className="product-btns">
                                {['54714781171785', '54714781204553', '54714781237321', '62111365792115'].includes(item.variantId) && !isRegular ? (
                                    ''
                                ) : (
                                    <div className="btn add-cart" onClick={() => handleBuy(item)}>
                                        Add To Cart
                                    </div>
                                )}
                                <div className="btn learn-more" onClick={() => handleLink(item.link_more, item)}>
                                    Learn More
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}

            <div className="swiper-button-prev" onClick={handlePrev} />
            <div className="swiper-button-next" onClick={handleNext} />
        </Swiper>
    );
};

const Emergency: React.FC = () => {
    const { locale } = getLocal();
    const { gtm } = useGlobal();
    const { t } = useLang('Emergency');

    const list: any = [
        {
            btnTitle: locale === 'us' ? '5 Days+' : 'Multi-Day',
            type: '5_days',
            pc:
                locale === 'us'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1749546472852/3.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1760082014083/Frame%20161269586.jpg',
            h5:
                locale === 'us'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1749797793850/h5-3.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1760088894720/H5-Frame%201612707566.jpg',
            icons: [
                {
                    comp: <Capacity />,
                    title: t('5_days_icon_1_title'),
                },
                {
                    comp: <Setup />,
                    title: t('5_days_icon_2_title'),
                },
                {
                    comp: <Seamless />,
                    title: t('5_days_icon_3_title'),
                },
                {
                    comp: <Phone />,
                    title: t('5_days_icon_4_title'),
                },
            ],
        },

        {
            btnTitle: '1-4 Days',
            type: '4_days',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749546473040/2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1749797794044/h5-2.jpg',
            icons: [
                {
                    comp: <Time />,
                    title: t('1_4_days_icon_1_title'),
                },
                {
                    comp: <Plug />,
                    title: t('1_4_days_icon_2_title'),
                },
                {
                    comp: <Energy />,
                    title: t('1_4_days_icon_3_title'),
                },
                {
                    comp: <Phone />,
                    title: t('1_4_days_icon_4_title'),
                },
            ],
        },
        {
            btnTitle: 'Hours',
            type: 'hours',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749546473251/1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1749797794236/h5-1.jpg',
            icons: [
                {
                    comp: <Plug />,
                    title: t('hours_icon_1_title'),
                },
                {
                    comp: <Compact />,
                    title: t('hours_icon_2_title'),
                },
                {
                    comp: <Outlets />,
                    title: t('hours_icon_3_title'),
                },
                {
                    comp: <Energy />,
                    title: t('hours_icon_4_title'),
                },
            ],
        },
    ];
    if (locale === 'us') {
        list.unshift({
            btnTitle: 'Multi-Day',
            type: 'Multi-Day',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1760082014083/Frame%20161269586.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1760088894720/H5-Frame%201612707566.jpg',
            icons: [
                {
                    comp: <MultiDay1 />,
                    title: t('Multi_icon_1_title'),
                },
                {
                    comp: <MultiDay2 />,
                    title: t('Multi_icon_2_title'),
                },
                {
                    comp: <Compact />,
                    title: t('Multi_icon_3_title'),
                },
                {
                    comp: <Outlets />,
                    title: t('Multi_icon_4_title'),
                },
            ],
        });
    }
    const [activeIndex, setActiveIndex] = useState(0);

    const { productList } = useProductList(locale);

    function handleClick(item: any, index: number) {
        setActiveIndex(index);
        const listItem = document.getElementById(`list-item-${index}`);
        if (listItem) {
            listItem.scrollIntoView({ behavior: 'smooth' });
        }
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'tab_click',
                button_name: item.btnTitle,
                list_name: 'Find Your Versatile Emergency Backup Power For',
            });
            // @ts-ignore
            twq('event', 'tw-o9mqq-ojfq3', {});
        } catch (error) {}
    }

    const [modalVisible, setModalVisible] = useState(false);
    const handleBuyChange = () => {
        setModalVisible(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_get_a_quote',
            product_name: 'EcoFlow Ocean Pro Be the First to Know_Get A quote',
        });
    };
    return (
        <div
            id="Emergency"
            className={`${styles.Emergency} Emergency GtmModuleData-section`}
            data-section-id={'powerPreparedness-Emergency'}
            data-section-title={t('title')}
        >
            <div className="page-space"></div>
            <EcoSectionCommon title={t('title')} />
            <div className="btns page-layout">
                {list.map((item, index) => (
                    <div className={`btn ${activeIndex === index ? 'active' : ''}`} key={index} onClick={() => handleClick(item, index)}>
                        {item.btnTitle}
                    </div>
                ))}
            </div>
            {locale === 'us' && (
                <div
                    className="GAQ-btn GtmModuleData-btn-common"
                    data-btn-id="GAQ_Btn_Emergency"
                    onClick={() => {
                        EcoDesignEventsBus.emit(OPEN_QUOTE_WIN_KEY, true);
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'floating_button',
                            button_name: `GAQ_Btn_Emergency`,

                            __btn_id1: `Emergency .GAQ-btn`,
                            __btn_id2: `GAQ_Btn_Emergency`,
                            __btn_type: 'common',
                        });
                    }}
                >
                    <img className="left-icon" src="https://websiteoss.ecoflow.com/upload/image/1764817232869/feedback.png" />
                    <span>{t('GAQ_BtnText')}</span>
                    <img className="right-icon" src="https://websiteoss.ecoflow.com/upload/image/1764817233229/icon-arrow.png" />
                </div>
            )}

            {list.map((listItem, index) => {
                return (
                    <div className={`list-item ${activeIndex === index ? 'active' : ''}`} id={`list-item-${index}`} key={index}>
                        <div className="img-wrapper">
                            <EcoImg pc={listItem.pc} h5={listItem.h5} />
                            <div className="wrapper">
                                <div className="text-box page-layout">
                                    <div className="label">{t(`img${index + 1}_label`)}</div>
                                    <div className="img-title">{t(`img${index + 1}_title`)}</div>
                                    <div className="desc">{t(`img${index + 1}_desc`)}</div>

                                    <div className="icons">
                                        {listItem.icons.map((item, index) => (
                                            <div className="icon" key={index}>
                                                {item.comp}
                                                <div className="title">{item.title}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="product-list page-layout">
                            <EmergencyItem productList={productList} listItem={listItem} />
                        </div>
                        {listItem?.productInfo && (
                            <div className="product-wrapper">
                                <div className="product-content">
                                    <EcoImg
                                        className="product-img"
                                        pc={listItem.productInfo.img.pc}
                                        pad={listItem.productInfo.img.pad}
                                        h5={listItem.productInfo.img.h5}
                                    />
                                    <div className="text-wrapper">
                                        <EcoSection
                                            className="info-section"
                                            label={listItem?.productInfo?.label}
                                            title={listItem?.productInfo?.title}
                                            desc={listItem?.productInfo?.desc}
                                        />
                                        <div className="btn-wrapper">
                                            <EcoButton
                                                className="learn-more"
                                                lChildren={listItem?.productInfo?.btn}
                                                lHref={listItem?.productInfo?.herf}
                                                lTheme="black"
                                                lType="filled"
                                                lDataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'select_product',
                                                    list_name: listItem?.productInfo?.label,
                                                    product_name: listItem?.productInfo?.title,
                                                    button_name: listItem?.productInfo?.btn,
                                                }}
                                            />
                                            <EcoButton
                                                className="learn-more"
                                                lChildren={listItem?.productInfo?.btn2}
                                                lHref={'javascript:void(0)'}
                                                onClick={handleBuyChange}
                                                lTheme="black"
                                                lType="filled"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}
            <PartnerModal visible={modalVisible} onClose={() => setModalVisible(false)} />
        </div>
    );
};

export default Emergency;
